import elements from 'modules/overlay-canvas/addons/elements';
import { BasePlaceholder } from '../base';
import { createIndicatorsRow, OrientationEnum, ShapeEnum } from './indicators-row';
import { DEFAULT_SHOOTOUT_COLORS, paintShootoutIndicators, previewShootoutAttempts } from './shootout-indicators';

/**
 * Цепочка ударов серии послематчевых пенальти: ряд индикаторов, где каждый
 * закрашен по исходу своего удара. Геометрия ряда общая с фолами в тайме
 * (`createIndicatorsRow`), разница только в раскраске.
 */
class TeamShootoutSeries extends BasePlaceholder {
  create() {
    const { left, top } = elements.getLeftTop(this.canvas);

    const background = this.createRect({
      options: {
        height: 60,
      },
    });

    background.set({
      data: {
        ...background.data,
        id: 'background',
      },
    });

    const data = {
      indicator: 'teamShootoutSeries',
      type: 'composition',
      unground: false,
      teamIndex: 0,
      // Пять ударов — базовая серия. Регламент чемпионата тут не указ: серия часто
      // уходит дальше, а место на табло размечает шаблон, а не правила.
      maxCount: 5,
      shape: ShapeEnum.CIRCLE,
      spacing: 10,
      orientation: OrientationEnum.HORIZONTAL,
      ...DEFAULT_SHOOTOUT_COLORS,
    };

    const backgroundWidth = background.width || 300;
    const backgroundHeight = background.height || 60;

    const indicators = createIndicatorsRow({
      maxCount: data.maxCount,
      color: data.pendingColor,
      spacing: data.spacing,
      orientation: data.orientation,
      shape: data.shape,
      width: backgroundWidth,
      height: backgroundHeight,
    });
    paintShootoutIndicators(indicators, previewShootoutAttempts(data.maxCount), DEFAULT_SHOOTOUT_COLORS);

    const group = this.createGroup({
      objects: [background],
      data,
      options: {
        left,
        top,
      },
    });

    indicators.forEach((indicator) => {
      group.add(indicator);
    });

    return group;
  }
}

export default TeamShootoutSeries;
